import { fetchDataAndProceed } from '../../config/utils';
import { METHOD_TYPES } from '../../config/constants';

export const getMessageTimeSeries = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/analytics/messagesTimeSeries', METHOD_TYPES.GET, data, callback);
};

export const getTrainingMessages = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/train/messages', METHOD_TYPES.GET, data, callback);
};

export const getTrainingMessageSuggestions = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/train/suggestions', METHOD_TYPES.GET, data, callback);
};

export const TrainMessage = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/train/utterances', METHOD_TYPES.PATCH, data, callback);
};



// WEBPACK FOOTER //
// ./src/data/redux/chatlog_details/api.js